/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  BillingCreditCostListParams,
  BillingPlanListParams,
  BillingTransactionListParams,
  BillingUsageSummary200,
  CreditCost,
  CreditWallet,
  PaginatedCreditTransactionList,
  PaginatedPlanList,
  Subscription,
} from "../../models";

import { customInstance } from "../../custom-instance";
import type { ErrorType } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * 활성화된 작업별 크레딧 단가를 반환합니다 (인증 불필요, 결제/안내 페이지용).
 * @summary 크레딧 단가 목록
 */
export const billingCreditCostList = (
  params?: BillingCreditCostListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CreditCost[]>(
    { url: `/api/billing/credit-costs/`, method: "GET", params, signal },
    options,
  );
};

export const getBillingCreditCostListQueryKey = (
  params?: BillingCreditCostListParams,
) => {
  return [`/api/billing/credit-costs/`, ...(params ? [params] : [])] as const;
};

export const getBillingCreditCostListQueryOptions = <
  TData = Awaited<ReturnType<typeof billingCreditCostList>>,
  TError = ErrorType<unknown>,
>(
  params?: BillingCreditCostListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingCreditCostList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBillingCreditCostListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof billingCreditCostList>>
  > = ({ signal }) => billingCreditCostList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof billingCreditCostList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BillingCreditCostListQueryResult = NonNullable<
  Awaited<ReturnType<typeof billingCreditCostList>>
>;
export type BillingCreditCostListQueryError = ErrorType<unknown>;

export function useBillingCreditCostList<
  TData = Awaited<ReturnType<typeof billingCreditCostList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | BillingCreditCostListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingCreditCostList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingCreditCostList>>,
          TError,
          Awaited<ReturnType<typeof billingCreditCostList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBillingCreditCostList<
  TData = Awaited<ReturnType<typeof billingCreditCostList>>,
  TError = ErrorType<unknown>,
>(
  params?: BillingCreditCostListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingCreditCostList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingCreditCostList>>,
          TError,
          Awaited<ReturnType<typeof billingCreditCostList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBillingCreditCostList<
  TData = Awaited<ReturnType<typeof billingCreditCostList>>,
  TError = ErrorType<unknown>,
>(
  params?: BillingCreditCostListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingCreditCostList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 크레딧 단가 목록
 */

export function useBillingCreditCostList<
  TData = Awaited<ReturnType<typeof billingCreditCostList>>,
  TError = ErrorType<unknown>,
>(
  params?: BillingCreditCostListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingCreditCostList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getBillingCreditCostListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 플랜 목록 (공개).
 * @summary 플랜 목록 조회
 */
export const billingPlanList = (
  params?: BillingPlanListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedPlanList>(
    { url: `/api/billing/plans/`, method: "GET", params, signal },
    options,
  );
};

export const getBillingPlanListQueryKey = (params?: BillingPlanListParams) => {
  return [`/api/billing/plans/`, ...(params ? [params] : [])] as const;
};

export const getBillingPlanListQueryOptions = <
  TData = Awaited<ReturnType<typeof billingPlanList>>,
  TError = ErrorType<unknown>,
>(
  params?: BillingPlanListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingPlanList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBillingPlanListQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof billingPlanList>>> = ({
    signal,
  }) => billingPlanList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof billingPlanList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BillingPlanListQueryResult = NonNullable<
  Awaited<ReturnType<typeof billingPlanList>>
>;
export type BillingPlanListQueryError = ErrorType<unknown>;

export function useBillingPlanList<
  TData = Awaited<ReturnType<typeof billingPlanList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | BillingPlanListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingPlanList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingPlanList>>,
          TError,
          Awaited<ReturnType<typeof billingPlanList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBillingPlanList<
  TData = Awaited<ReturnType<typeof billingPlanList>>,
  TError = ErrorType<unknown>,
>(
  params?: BillingPlanListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingPlanList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingPlanList>>,
          TError,
          Awaited<ReturnType<typeof billingPlanList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBillingPlanList<
  TData = Awaited<ReturnType<typeof billingPlanList>>,
  TError = ErrorType<unknown>,
>(
  params?: BillingPlanListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingPlanList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 플랜 목록 조회
 */

export function useBillingPlanList<
  TData = Awaited<ReturnType<typeof billingPlanList>>,
  TError = ErrorType<unknown>,
>(
  params?: BillingPlanListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingPlanList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getBillingPlanListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 현재 구독 상태 조회.
 * @summary 구독 상태 조회
 */
export const billingSubscription = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<Subscription>(
    { url: `/api/billing/subscription/`, method: "GET", signal },
    options,
  );
};

export const getBillingSubscriptionQueryKey = () => {
  return [`/api/billing/subscription/`] as const;
};

export const getBillingSubscriptionQueryOptions = <
  TData = Awaited<ReturnType<typeof billingSubscription>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof billingSubscription>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBillingSubscriptionQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof billingSubscription>>
  > = ({ signal }) => billingSubscription(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof billingSubscription>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BillingSubscriptionQueryResult = NonNullable<
  Awaited<ReturnType<typeof billingSubscription>>
>;
export type BillingSubscriptionQueryError = ErrorType<unknown>;

export function useBillingSubscription<
  TData = Awaited<ReturnType<typeof billingSubscription>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingSubscription>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingSubscription>>,
          TError,
          Awaited<ReturnType<typeof billingSubscription>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBillingSubscription<
  TData = Awaited<ReturnType<typeof billingSubscription>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingSubscription>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingSubscription>>,
          TError,
          Awaited<ReturnType<typeof billingSubscription>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBillingSubscription<
  TData = Awaited<ReturnType<typeof billingSubscription>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingSubscription>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 구독 상태 조회
 */

export function useBillingSubscription<
  TData = Awaited<ReturnType<typeof billingSubscription>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingSubscription>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getBillingSubscriptionQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 크레딧 거래 내역 목록.
 * @summary 크레딧 거래 내역
 */
export const billingTransactionList = (
  params?: BillingTransactionListParams,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<PaginatedCreditTransactionList>(
    { url: `/api/billing/transactions/`, method: "GET", params, signal },
    options,
  );
};

export const getBillingTransactionListQueryKey = (
  params?: BillingTransactionListParams,
) => {
  return [`/api/billing/transactions/`, ...(params ? [params] : [])] as const;
};

export const getBillingTransactionListQueryOptions = <
  TData = Awaited<ReturnType<typeof billingTransactionList>>,
  TError = ErrorType<unknown>,
>(
  params?: BillingTransactionListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingTransactionList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBillingTransactionListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof billingTransactionList>>
  > = ({ signal }) => billingTransactionList(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof billingTransactionList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BillingTransactionListQueryResult = NonNullable<
  Awaited<ReturnType<typeof billingTransactionList>>
>;
export type BillingTransactionListQueryError = ErrorType<unknown>;

export function useBillingTransactionList<
  TData = Awaited<ReturnType<typeof billingTransactionList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | BillingTransactionListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingTransactionList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingTransactionList>>,
          TError,
          Awaited<ReturnType<typeof billingTransactionList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBillingTransactionList<
  TData = Awaited<ReturnType<typeof billingTransactionList>>,
  TError = ErrorType<unknown>,
>(
  params?: BillingTransactionListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingTransactionList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingTransactionList>>,
          TError,
          Awaited<ReturnType<typeof billingTransactionList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBillingTransactionList<
  TData = Awaited<ReturnType<typeof billingTransactionList>>,
  TError = ErrorType<unknown>,
>(
  params?: BillingTransactionListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingTransactionList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 크레딧 거래 내역
 */

export function useBillingTransactionList<
  TData = Awaited<ReturnType<typeof billingTransactionList>>,
  TError = ErrorType<unknown>,
>(
  params?: BillingTransactionListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingTransactionList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getBillingTransactionListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 이번 달 사용량 요약 — billing 페이지 미니 차트용.

응답: { spent_this_month, granted_this_month, plan_monthly_credits, balance, last_grant_at }
 * @summary 이번 달 크레딧 사용량 요약
 */
export const billingUsageSummary = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<BillingUsageSummary200>(
    { url: `/api/billing/usage/`, method: "GET", signal },
    options,
  );
};

export const getBillingUsageSummaryQueryKey = () => {
  return [`/api/billing/usage/`] as const;
};

export const getBillingUsageSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof billingUsageSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof billingUsageSummary>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBillingUsageSummaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof billingUsageSummary>>
  > = ({ signal }) => billingUsageSummary(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof billingUsageSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BillingUsageSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof billingUsageSummary>>
>;
export type BillingUsageSummaryQueryError = ErrorType<unknown>;

export function useBillingUsageSummary<
  TData = Awaited<ReturnType<typeof billingUsageSummary>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingUsageSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingUsageSummary>>,
          TError,
          Awaited<ReturnType<typeof billingUsageSummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBillingUsageSummary<
  TData = Awaited<ReturnType<typeof billingUsageSummary>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingUsageSummary>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingUsageSummary>>,
          TError,
          Awaited<ReturnType<typeof billingUsageSummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBillingUsageSummary<
  TData = Awaited<ReturnType<typeof billingUsageSummary>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingUsageSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 이번 달 크레딧 사용량 요약
 */

export function useBillingUsageSummary<
  TData = Awaited<ReturnType<typeof billingUsageSummary>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingUsageSummary>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getBillingUsageSummaryQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * 사용자 크레딧 지갑 조회.
 * @summary 크레딧 잔액 조회
 */
export const billingWallet = (
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<CreditWallet>(
    { url: `/api/billing/wallet/`, method: "GET", signal },
    options,
  );
};

export const getBillingWalletQueryKey = () => {
  return [`/api/billing/wallet/`] as const;
};

export const getBillingWalletQueryOptions = <
  TData = Awaited<ReturnType<typeof billingWallet>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof billingWallet>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBillingWalletQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof billingWallet>>> = ({
    signal,
  }) => billingWallet(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof billingWallet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BillingWalletQueryResult = NonNullable<
  Awaited<ReturnType<typeof billingWallet>>
>;
export type BillingWalletQueryError = ErrorType<unknown>;

export function useBillingWallet<
  TData = Awaited<ReturnType<typeof billingWallet>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingWallet>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingWallet>>,
          TError,
          Awaited<ReturnType<typeof billingWallet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBillingWallet<
  TData = Awaited<ReturnType<typeof billingWallet>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingWallet>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingWallet>>,
          TError,
          Awaited<ReturnType<typeof billingWallet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useBillingWallet<
  TData = Awaited<ReturnType<typeof billingWallet>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingWallet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary 크레딧 잔액 조회
 */

export function useBillingWallet<
  TData = Awaited<ReturnType<typeof billingWallet>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingWallet>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getBillingWalletQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
